import { render, staticRenderFns } from "./CompanyInfo_Categories.vue?vue&type=template&id=63dc32ad&scoped=true"
import script from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_Categories.vue?vue&type=style&index=0&id=63dc32ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc32ad",
  null
  
)

export default component.exports